import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

export function formatRelativeTime(timeUTC: any, withSuffix = true) {
  const time: Dayjs = dayjs.utc(timeUTC);
  const now: Dayjs = dayjs.utc();
  const diffInSeconds = now.diff(time, 'second');

  if (diffInSeconds < 60) {
    return 'now';
  }

  const diffInMinutes = now.diff(time, 'minute');
  if (diffInMinutes < 60) {
    return withSuffix ? `${diffInMinutes}m ago` : `${diffInMinutes}m`;
  }

  const diffInHours = now.diff(time, 'hour');
  if (diffInHours < 24) {
    return withSuffix ? `${diffInHours}h ago` : `${diffInHours}h`;
  }

  const diffInDays = now.diff(time, 'day');
  if (diffInDays < 365) {
    return withSuffix ? `${diffInDays}d ago` : `${diffInDays}d`;
  }

  return now.to(time, true);
}
